module.exports = __webpack_public_path__ + "static/media/Servicos2.02e74ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadServicos/Servicos2.png
// module id = 2117
// module chunks = 0